import { gql } from '@apollo/client';

export const GET_CMS_CONTAINER = gql`
  query getCmsContainer($containerId: String!) {
    getCmsContainer(containerId: $containerId) {
      container {
        containerId
        containerName
        size
        metadata: metadataStruct {
          section
          aisle
          level
          alphabetIdentifier
          isCompliant
        }
        parentlocation {
          type
          value
        }
        isActive
        state
        version
        seals {
          sealId
          verifiedBy
          timestamp
        }
        tickets {
          ticketId
          verifiedBy
          timestamp
        }
      }
      location {
        locationClass
        locationId
        locationName
        parentId
        zone
      }
      containerDefinition {
        category
        subcategory
        containerType
        metadataConfiguration: metadataConfigurationStruct {
          section {
            default: defaultValue
          }
          aisle {
            default: defaultValue
          }
          level {
            default: defaultValue
          }
          alphabetIdentifier {
            default: defaultValue
          }
          cctvRequired {
            default: defaultValue
          }
          sealIdRequired {
            default: defaultValue
          }
          ticketIdRequired {
            default: defaultValue
          }
          containerNamePrefix {
            default: defaultValue
          }
          virtualBinType {
            default: defaultValue
          }
          validationsRequired {
            default: defaultValue
          }
          moveSupport {
            supportedParentLocations
          }
        }
      }
      policies {
        policyId
        statements {
          effect: Effect
          action: Action
          resource: Resource
        }
      }
    }
  }
`;

export const GET_CMS_CONTAINER_BY_ASSET_TAG = gql`
  query getCmsContainerByAssetTag($assetTag: String!) {
    getCmsContainerByAssetTag(assetTag: $assetTag) {
      container {
        containerId
        containerName
        size
        metadata: metadataStruct {
          section
          aisle
          level
          alphabetIdentifier
          isCompliant
        }
        parentlocation {
          type
          value
        }
        isActive
        state
        version
        seals {
          sealId
          verifiedBy
          timestamp
        }
      }
      location {
        locationClass
        locationId
        locationName
        parentId
        zone
      }
      containerDefinition {
        category
        subcategory
        containerType
        metadataConfiguration: metadataConfigurationStruct {
          section {
            default: defaultValue
          }
          aisle {
            default: defaultValue
          }
          level {
            default: defaultValue
          }
          alphabetIdentifier {
            default: defaultValue
          }
          cctvRequired {
            default: defaultValue
          }
          sealIdRequired {
            default: defaultValue
          }
          ticketIdRequired {
            default: defaultValue
          }
          containerNamePrefix {
            default: defaultValue
          }
          virtualBinType {
            default: defaultValue
          }
          validationsRequired {
            default: defaultValue
          }
          moveSupport {
            supportedParentLocations
          }
        }
      }
      policies {
        policyId
        statements {
          effect: Effect
          action: Action
          resource: Resource
        }
      }
    }
  }
`;

export const VALIDATE_CONTAINER_MOVEMENT = gql`
  query validateContainerMovement(
    $sourceContainerDefinitionId: String
    $sourceContainerName: String!
    $destinationType: String!
    $destinationName: String!
  ) {
    validateContainerMovement(
      sourceContainerDefinitionId: $sourceContainerDefinitionId
      sourceContainerName: $sourceContainerName
      destinationType: $destinationType
      destinationName: $destinationName
    ) {
      sourceContainerName
      destinationType
      destinationName
      movementValidated
    }
  }
`;

export const GET_CMS_CONTAINER_HISTORY = gql`
  query getCmsContainerHistory($containerId: String!, $start: Int, $maxResults: Int) {
    getCmsContainerHistory(containerId: $containerId, start: $start, maxResults: $maxResults) {
      history {
        containerId
        containerName
        size
        metadata: metadataStruct {
          section
          aisle
          level
          alphabetIdentifier
        }
        isActive
        version
        containerDefinitionId
        locationId
        policyIds
        versionData {
          user
          role
          reasonCodes
          updatedDateTime
        }
        state
        parentLocation {
          type
          value
        }
        seals {
          sealId
          verifiedBy
          timestamp
        }
        tickets {
          ticketId
          verifiedBy
          timestamp
        }
      }
      containerDefinitionMap
      locationMap
      policyMap
      reasonCodeMap
    }
  }
`;

export const GET_CMS_LIST_SITES = gql`
  query listSites {
    listSites {
      locations {
        locationName
        locationId
        locationClass
        parentId
      }
    }
  }
`;

export const LIST_CONTAINER_TYPES = gql`
  query listContainerTypes {
    listContainerTypes {
      containerTypes
    }
  }
`;

export const GET_LIST_CONTAINER_DEFINITION = gql`
  query listContainerDefinitions($containerType: String!) {
    listContainerDefinitions(containerType: $containerType) {
      containerType
      categories
    }
  }
`;

export const GET_POLICIES = gql`
  query getCMSPolicies($policyIds: [String]!) {
    getPolicies(policyIds: $policyIds) {
      policies {
        policyId
        statements {
          effect: Effect
          action: Action
          resource: Resource
        }
      }
    }
  }
`;

export const GET_LOCATIONS_FOR_SITE = gql`
  query getLocationsforSite($locationId: String!) {
    getLocationsForSite(locationId: $locationId) {
      locations {
        locationClass
        locationId
        locationName
        parentId
        zone
      }
    }
  }
`;

export const LIST_CHILD_CONTAINER = gql`
  query getContainerHierarchy($containerName: String!) {
    getContainerHierarchy(containerName: $containerName) {
      childContainers {
        containerId
        containerName
        containerType
        parentContainerName
      }
      paginationNextToken
    }
  }
`;

export const VALIDATE_CONTAINER_OPERATION = gql`
  query validateContainerOperation($containerId: String!, $operation: String!) {
    validateContainerOperation(containerId: $containerId, operation: $operation) {
      isValid
    }
  }
`;

export const MOVE_CONTAINER = gql`
  mutation moveContainer($childContainerName: String!, $parentContainerName: String!) {
    moveContainer(
      childContainerName: $childContainerName
      parentContainerName: $parentContainerName
    ) {
      childContainerId
      parentContainerName
      childContainerName
    }
  }
`;

export const MOVE_CONTAINERS = gql`
  mutation moveContainers(
    $sourceContainerNames: [String]!
    $destinationType: String!
    $destinationName: String!
    $lastSiteID: String
  ) {
    moveContainers(
      sourceContainerNames: $sourceContainerNames
      destinationType: $destinationType
      destinationName: $destinationName
      lastSiteID: $lastSiteID
    ) {
      destinationName
      destinationType
      updatedSourceContainers {
        containerId
        containerName
        size
        metadata: metadataStruct {
          section
          aisle
          level
          alphabetIdentifier
          isCompliant
        }
        parentlocation {
          type
          value
        }
        isActive
        version
        seals {
          sealId
          verifiedBy
          timestamp
        }
      }
    }
  }
`;

export const CREATE_CONTAINERS = gql`
  mutation createContainers($containers: [RequestedContainer]!) {
    createContainers(containers: $containers) {
      createdContainers {
        containerInstance {
          containerId
          size
          metadata: metadataStruct {
            section
            aisle
            level
            alphabetIdentifier
          }
          containerName
          version
        }
        error
      }
    }
  }
`;

export const UPDATE_CONTAINER = gql`
  mutation updateContainer(
    $containerId: String!
    $containerDefinitionId: String
    $version: Int!
    $containerName: String
    $size: String
    $isActive: Boolean
    $state: String
    $metadataStruct: CMSMetadata
    $addedPolicyIds: [String]
    $removedPolicyIds: [String]
    $reasonCodes: [Int]!
  ) {
    updateContainer(
      containerId: $containerId
      containerDefinitionId: $containerDefinitionId
      version: $version
      containerName: $containerName
      size: $size
      isActive: $isActive
      state: $state
      metadataStruct: $metadataStruct
      addedPolicyIds: $addedPolicyIds
      removedPolicyIds: $removedPolicyIds
      reasonCodes: $reasonCodes
    ) {
      container {
        containerId
        isActive
        state
        metadata: metadataStruct {
          section
          aisle
          level
          alphabetIdentifier
          isCompliant
        }
        size
        version
      }
    }
  }
`;

export const CREATE_POLICY = gql`
  mutation createPolicy($statements: [StatementInput]!) {
    createPolicy(statements: $statements) {
      policy {
        policyId
      }
    }
  }
`;

export const DELETE_POLICY = gql`
  mutation deletePolicy($policyId: String!, $version: Int!, $containerId: String!) {
    deletePolicy(policyId: $policyId, version: $version, containerId: $containerId) {
      policyId
    }
  }
`;

export const UPDATE_SEALS = gql`
  mutation UpdateSeals(
    $containerId: String!
    $version: Int!
    $addedSeals: [SealInput]
    $removedSeals: [SealInput]
    $reasonCode: Int
  ) {
    updateSeals(
      containerId: $containerId
      version: $version
      addedSeals: $addedSeals
      removedSeals: $removedSeals
      reasonCode: $reasonCode
    ) {
      containerId
      seals {
        sealId
        verifiedBy
        timestamp
      }
    }
  }
`;

export const UPDATE_TICKETS = gql`
  mutation UpdateTickets(
    $containerId: String!
    $version: Int!
    $addedTickets: [TicketInput]
    $removedTickets: [TicketInput]
  ) {
    updateTickets(
      containerId: $containerId
      version: $version
      addedTickets: $addedTickets
      removedTickets: $removedTickets
    ) {
      containerId
      tickets {
        ticketId
        verifiedBy
        timestamp
      }
    }
  }
`;

export const GET_CONTAINER_PERMISSIONS = gql`
  query getContainerPermissionsCheck {
    getContainerPermissionsCheck {
      user
    }
  }
`;

export const MANAGE_CONTAINER_PERMISSIONS = gql`
  query manageContainerPermissionsCheck {
    manageContainerPermissionsCheck {
      user
    }
  }
`;

export const GET_PARTS = gql`
  query getParts(
    $containerId: String!
    $containerFullName: String
    $containerType: String
    $maxResults: Int
    $from: Int
  ) {
    getParts(
      containerId: $containerId
      containerFullName: $containerFullName
      containerType: $containerType
      maxResults: $maxResults
      from: $from
    ) {
      totalResults
      parts {
        serialId
        model
        vendor
        type
        state
      }
    }
  }
`;

export const GET_CYCLE_COUNT_HISTORY = gql`
  query getCycleCountHistory($containerId: String!, $maxResults: Int!) {
    getCycleCountHistory(containerId: $containerId, maxResults: $maxResults) {
      cycleCountHistory {
        user
        missing
        date
        type
        checked
        newlyAdded
      }
    }
  }
`;

export const GET_CHILD_CONTAINERS = gql`
  query GetChildContainers($containerIdentifier: String!) {
    getChildContainers(containerIdentifier: $containerIdentifier) {
      containerId
      containerName
      containerType
      status
    }
  }
`;

export const DELETE_CONTAINER = gql`
  mutation deleteContainer($containerId: String!, $version: Int!, $reasonCode: Int!) {
    deleteContainer(containerId: $containerId, version: $version, reasonCode: $reasonCode) {
      containerId
    }
  }
`;

export const CMS_APP_CONFIG = gql`
  query getAppConfig($name: String, $key: String) {
    getAppConfig(name: $name, key: $key) {
      value
    }
  }
`;

export const SEARCH_CONTAINER = gql`
  query searchContainer(
    $searchString: String
    $roomId: String
    $type: String
    $category: String
    $subcategory: String
    $siteId: String!
    $siteIds: [String]
    $isCompliant: String
    $isEmpty: String
    $zone: String
    $from: Int
    $size: Int
    $state: String
    $userAlias: String
    $parentContainerName: String
    $parentContainerType: String
    $sortOptions: [SortOptionInput]
  ) {
    searchContainer(
      searchString: $searchString
      roomId: $roomId
      type: $type
      category: $category
      subcategory: $subcategory
      siteId: $siteId
      siteIds: $siteIds
      isCompliant: $isCompliant
      isEmpty: $isEmpty
      zone: $zone
      from: $from
      size: $size
      state: $state
      parentContainerName: $parentContainerName
      parentContainerType: $parentContainerType
      userAlias: $userAlias
      sortOptions: $sortOptions
    ) {
      totalResults
      documents {
        data {
          containerId: container_id
          cell: container_name
          name: fq_container_name
          containerType: container_type
          category
          subcategory
          cctvRequired: cctv_required
          size
          isActive
          lastUpdatedUser: last_updated_by
          createdBy: created_by
          lastUpdatedTime: last_updated_timestamp
          creationTime: creation_timestamp
          containerDefinitionId: container_definition_id
          locationId: location_id
          site: metadata_location_site {
            name
            equipmentId
          }
          room: metadata_location_room {
            name
            equipmentId
            zone
          }
          current_version
          seal_ids
          ticket_ids
          parent_container: parent_container {
            id
            name
            type
            fq_name
          }
          userAlias: user_custody
          move_support: move_support
          state: state
          section: metadata_section
          aisle: metadata_aisle
          level: metadata_level
          alphabetIdentifier: metadata_alphabetIdentifier
          isCompliant: metadata_isCompliant
          isEmpty: metadata_isEmpty
          hasOverriddenRules: has_overridden_rules
          policy {
            rule {
              name
              policyId: id
            }
          }
        }
      }
    }
  }
`;
